import { downloadCSV, getAPI, postAPI } from "./Networking";
import {
  APIBlobResponse,
  APIResponse,
  PaginatedAPIResponse,
} from "../models/NetworkResponse";
import { SwageazyInventoryFilters } from "../models/SwageazyInventory/SwageazyInventoryFilter";
import {
  SwageazyInventoryDetails,
  SwageazyInventoryInwardRequestFormData,
  SwageazyInventoryOutwardRequestFormData,
  SwageazyInventorySampleReturnRequestFormData,
  ProductStockDetails,
  BlockedQuantityDetailsModel,
  PurchaseOrderProductDetails,
} from "../models/SwageazyInventory/SwageazyInventory";
import { PurchaseRequestBody } from "../models/PurchaseRequest/PurchaseRequestBody";

export default class SwageazyInventoryAPI {
  getSwageazyInventoryListing = async (
    filters: SwageazyInventoryFilters,
  ): Promise<PaginatedAPIResponse<SwageazyInventoryDetails>> => {
    try {
      const queryParams = new URLSearchParams();

      if (filters.page_no !== undefined)
        queryParams.append("page_no", filters.page_no.toString());

      if (filters.limit !== undefined)
        queryParams.append("limit", filters.limit.toString());

      if (filters.search_text)
        queryParams.append("search_text", filters.search_text);

      if (filters.warehouse_id)
        queryParams.append("warehouse_id", filters.warehouse_id);

      if (filters.sort_by) queryParams.append("sort_by", filters.sort_by);

      if (filters.sort_type) queryParams.append("sort_type", filters.sort_type);

      const response = await getAPI(
        `/v5/inventories/swageazy?${queryParams.toString()}`,
      );

      return response.result;
    } catch (error) {
      throw error;
    }
  };

  downloadSwageazyInventoryReport = async (
    filters: SwageazyInventoryFilters,
  ): Promise<APIBlobResponse> => {
    try {
      const queryParams = new URLSearchParams();

      if (filters.search_text)
        queryParams.append("search_text", filters.search_text);

      if (filters.warehouse_id)
        queryParams.append("warehouse_id", filters.warehouse_id);

      queryParams.append("download_report", true.toString());
      const response = await downloadCSV(
        `/v5/inventories/swageazy/download?${queryParams.toString()}`,
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  createSwageazyInventoryPurchaseRequest = async (
    data: PurchaseRequestBody,
  ): Promise<APIResponse> => {
    try {
      const response = await postAPI(
        `/admin/purchaseRequest/saveSwageazyRequest`,
        {
          purchase_request: data,
        },
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  getPurchaseOrderNumbers = async (
    searchText: string,
  ): Promise<PurchaseOrderProductDetails> => {
    try {
      const response = await getAPI(
        `/v5/inventories/swageazy/purchase-order-products?page_no=1&search_text=${searchText}&limit=100`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  generateBoxId = async (
    current_rack: string,
    warehouse_id: string,
  ): Promise<APIResponse> => {
    try {
      const response = await postAPI(`/v5/inventories/warehouse/boxes`, {
        current_rack: current_rack,
        warehouse_id: warehouse_id,
      });
      return response;
    } catch (error) {
      throw error;
    }
  };

  createSwageazyInventoryInwardTransfer = async (
    data: SwageazyInventoryInwardRequestFormData,
  ): Promise<APIResponse> => {
    try {
      const response = await postAPI(`/v5/inventories/swageazy/credit`, data);
      return response;
    } catch (error) {
      throw error;
    }
  };

  createSwageazyInventoryOutwardTransfer = async (
    data: SwageazyInventoryOutwardRequestFormData,
  ): Promise<APIResponse> => {
    try {
      const response = await postAPI(`/v5/inventories/swageazy/debit`, data);
      return response;
    } catch (error) {
      throw error;
    }
  };

  sampleReturn = async (
    data: SwageazyInventorySampleReturnRequestFormData,
  ): Promise<APIResponse> => {
    try {
      const response = await postAPI(`/v5/inventories/swageazy/return`, data);
      return response;
    } catch (error) {
      throw error;
    }
  };

  BlockedQuantityDetails = async (
    po_id: number,
    product_id: number,
    warehouse_id: number | string,
  ): Promise<BlockedQuantityDetailsModel> => {
    try {
      const response = await postAPI(`/v5/inventories/swageazy/stock/blocked`, {
        po_id: po_id,
        product_id: product_id,
        warehouse_id: warehouse_id,
      });
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  getProductStockDetails = async (
    product_id: number,
  ): Promise<ProductStockDetails> => {
    try {
      const response = await getAPI(
        `/v5/inventories/swageazy/product/${product_id}`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  getProductTransactions = async (product_id: number): Promise<APIResponse> => {
    try {
      const response = await getAPI(
        `/v5/inventories/swageazy/product/${product_id}/transactions`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };
}
